<template>
  <div class="gotit-tabs-container">
    <div class="tabs">
      <ul>
        <li v-for="(tab, i) in tabs" :key="'tabs' + i" :class="{ 'is-active': tab.isActive, 'empty': tab.empty }">
          <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
        </li>
      </ul>
    </div>
    <div class="clear" />
    <div class="tabs-details">
      <slot />
    </div>
  </div>
</template>

<script>
import * as delay from 'delay'

export default {
  name: 'Tabs',
  data () {
    return { tabs: [] }
  },
  mounted () {
    this.tabs = this.$children
  },
  methods: {
    async selectTab (selectedTab) {
      while (this.$children.length === 1) {
        await delay(200)
      }
      this.tabs = this.$children
      this.tabs.forEach((tab) => {
        tab.isActive = (tab.name.toLowerCase() === selectedTab.name.toLowerCase())
      })
    }
  }
}
</script>

<style scoped>

  .clear {
    clear: both;
  }

  ul {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #dbdbdb;
    list-style-type: none;
    width: 900px;
    justify-content: center;
  }

  .mobile_design ul, .mobile_design .tabs {
    width: 100%;
  }

  .mobile_design li {
    width: 50%;
  }

  .tabs {
    display: flex;
    flex-direction: column;
    clear: both;
    align-items: center;
  }

  .tabs:not(:last-child) {
    margin-bottom: 1.5rem;
  }

  .mobile_design .tabs:not(:last-child) {
    margin-bottom: 0;
  }

  .tabs a {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    color: #4a4a4a;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-bottom: -1px;
    padding: .5em 1em;
    vertical-align: top;
  }

  a {
    color: #00d1b2;
    cursor: pointer;
    -webkit-transition: none 86ms ease-out;
    transition: none 86ms ease-out;
    text-decoration: none !important;
  }

  .mobile_design a {
    font-size: 14px;
  }
  .is-active a {
    color: #ed4956;
    border-bottom: 1px solid #ed4956;
  }

  .empty a {
    border-bottom: unset;
    width: 200px;
  }

  .mobile_design .tabs-details {
    width: 100%;
  }

  .mobile_design .gotit-tabs-container {
    /*height: calc(100% - 14em);*/
    display: flex;
  }

  .mobile_design .gotit-tabs-container .tabs-details {
    /*height: calc(100% - 14em);*/
    flex-grow: 1;
  }

</style>
